import { ExclamationCircleFilled } from '@ant-design/icons';
import { useScrollTop } from 'hooks';
import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  && {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-top: 100px;
    .red {
      color: red;
    }
    p {
      text-align: center;
    }
  }
`;

const Error = () => {
  useScrollTop();
  return (
    <Wrap>
      <ExclamationCircleFilled style={{ color: 'red', fontSize: '70px', marginBottom: '50px' }} />
      <p className="extraLargeFont red">指定したページは存在していません。</p>
    </Wrap>
  );
};

export default Error;
